// Obfuscated video URL
const videoUrl = atob('aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL2V3LWFzc2V0cy9ldy9MYW5kaW5nL2V3LXN0dWRpby1yZWVsLTE2LTktZGVjMjAyMy0yLm1wNA==');

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex flex-col items-center justify-center pt-20 max-sm:pt-0">
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover"
          src={videoUrl}
          autoPlay
          loop
          muted
          playsInline
          onContextMenu={(e) => e.preventDefault()}
        />
        <div className="absolute inset-0 bg-black/50 z-10"></div>
      </div>

      <div className="ml-0 container-custom relative z-20 mt-4 w-full">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between text-center md:text-left max-w-5xl mx-auto">

          {/* Mobile Minimal Layout */}
          <div className="sm:hidden w-full px-6 flex flex-col justify-end h-full pt-24 pb-28">
            <span className="text-white/60 font-mono text-xs tracking-[0.2em] mb-5 text-left uppercase animate-fade-in block">
              The Future is Now
            </span>
            <h1 className="animate-fade-in text-5xl font-bold leading-[1.05] text-left tracking-tight text-white mb-6">
              Elevating <br /> <span className="text-white/70">Digital <br /> Presence.</span>
            </h1>
            <p className="text-white/80 text-left text-lg font-light max-w-[90%] leading-relaxed animate-fade-in stagger-delay-1">
              We build high-performance websites, SEO strategies, and AI systems that scale businesses.            </p>
          </div>

          {/* Floating Action Bar (Mobile Only) */}
          <div className="sm:hidden absolute bottom-20 left-4 right-4 z-30 animate-fade-in stagger-delay-2">
            <div className="flex items-center gap-2 bg-black/40 backdrop-blur-xl p-1.5 rounded-[20px] border border-white/10 shadow-2xl">
              <a href="/clientportal" className="flex-1 btn btn-primary py-4 text-sm font-medium rounded-2xl flex items-center justify-center bg-white text-black hover:bg-white/90 shadow-lg tracking-wide">
                Start Project
              </a>
              <a href="https://calendly.com/nuviosites/30min" className="flex-1 btn btn-primary py-4 text-sm font-medium rounded-2xl flex items-center justify-center bg-transparent border border-white/20 text-white hover:bg-white/5 tracking-wide">
                Book Call
              </a>
            </div>
          </div>

          {/* Desktop Content (Hidden on Mobile) */}
          <div className="hidden sm:flex flex-col max-w-2xl px-6 sm:px-0">
            <h1 className="animate-fade-in text-8xl font-bold leading-tight text-left">
              <span className="text-white block">
                AI - Powered Solutions
              </span>
            </h1>

            <p className="mt-6 text-xl text-white/70 animate-fade-in stagger-delay-1 text-left max-w-prose drop-shadow-md">
              We craft exceptional websites and AI solutions that drive growth, enhance user experience, and automate complex processes.
            </p>
          </div>

          <div className="hidden sm:flex mt-10 flex-col sm:flex-row gap-4 animate-fade-in stagger-delay-2 px-6 sm:px-0 w-full">
            <a href="#services" className="btn btn-primary">
              View Our Work
            </a>
            <a href="/clientportal" className="btn btn-outline">
              Start Your Project
            </a>
            <a href="https://calendly.com/nuviosites/30min" className="btn btn-primary">
              Book a meeting
            </a>
          </div>
        </div>

        {/* Marquee Section */}
        <section className="daarzy-scrolling-text mt-10 mb-4">
          <div className="daarzy-marquee">
            <div className="daarzy-marquee-inner">
              <div className="daarzy-marquee-content">
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Fast Performance</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Seamless UX</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Modern Design</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Innovative Ideas</span>
              </div>
              {/* Duplicate for smooth looping */}
              <div className="daarzy-marquee-content" aria-hidden="true">
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Fast Performance</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Seamless UX</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Modern Design</span>
                <img
                  className="daarzy-icon"
                  src="http://daarzy.com/wp-content/uploads/2025/02/Group-84-1.svg"
                  alt="Daarzy Icon"
                />
                <span className="daarzy-item">Innovative Ideas</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <style>{`
        video {
          pointer-events: none;
        }
        .daarzy-scrolling-text {
          width: 100%;
          overflow: hidden;
        }
        .daarzy-marquee {
          display: flex;
          overflow: hidden;
          user-select: none;
        }
        .daarzy-marquee-inner {
          display: flex;
          flex-shrink: 0;
          animation: marquee-scroll 20s linear infinite;
        }
        .daarzy-marquee-content {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 0 1rem;
        }
        .daarzy-icon {
          width: 24px;
          height: 24px;
        }
        .daarzy-item {
          font-size: 1.25rem;
          color: white;
          font-weight: 500;
        }
        @keyframes marquee-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .daarzy-marquee:hover .daarzy-marquee-inner {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Hero;